import { render, staticRenderFns } from "./ShopDetailsStoreOut.vue?vue&type=template&id=67b4243b&scoped=true"
import script from "./ShopDetailsStoreOut.vue?vue&type=script&lang=js"
export * from "./ShopDetailsStoreOut.vue?vue&type=script&lang=js"
import style0 from "./ShopDetailsStoreOut.vue?vue&type=style&index=0&id=67b4243b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4243b",
  null
  
)

export default component.exports